import user from "../mock/user.json";

export const apiConfig = {
    getServiceUrl: () => import.meta.env.VITE_REACT_APP_API_BASE_URL,
    getPassportUrl: () => import.meta.env.VITE_REACT_APP_PASSPORT_URL,
    platformURL: import.meta.env.VITE_REACT_APP_PLATFORM_URL,
    mock: {
        // GET
        get_User: () => user,

        // POST
        post_SubmitForm: (params) => {
            const { values } = params;
            const { firstName, lastName } = values;
            if (firstName === "Nicolas" && lastName.length > 0) return { newTicket: 123456 };
            else return { error: { message: "Wrong name", code: 10 } };
        }
    }
};
